import { Tag as AntTag } from "antd";
import "./style.scss";
import { DislikesIcon, LikesIcon } from "assets/icons";

function Tag({
  icon,
  children,
  variant,
  isActive,
  uppercase,
  onClick,
  className,
  closable,
  readOnly,
  color,
}) {
  // Variants And class name
  const tagClass = `
  ${uppercase ? "uppercase-tag" : ""} 
  ${variant === "like" ? "like-tag" : ""} 
  ${variant === "dislike" ? "dislike-tag" : ""} 
  ${variant === "yellow" ? "yellow-tag" : ""} 
  ${variant === "selection" ? "selection-tag" : ""} 
  ${variant === "timer" ? "timer-tag" : ""}
  ${variant === "success" ? "success-tag" : ""}
  ${variant === "rejected" ? "rejected-tag" : ""}
  ${isActive ? "active" : ""} 
    ${readOnly ? "read-only" : ""}
  ${className || ""}
`;

  //icons for like & dislike
  if (variant === "like") {
    icon = <LikesIcon />;
  } else if (variant === "dislike") {
    icon = <DislikesIcon />;
  }

  //non-checkable tag with closable
  if (
    closable ||
    variant === "like" ||
    variant === "dislike" ||
    variant === "timer" ||
    variant === "yellow"
  ) {
    return (
      <AntTag
        closable={closable}
        onClose={onClick}
        icon={icon}
        className={tagClass}
        color={color}
      >
        {children}
      </AntTag>
    );
  }

  return (
    <AntTag.CheckableTag
      checked={isActive}
      onClick={onClick}
      icon={icon}
      closable={closable}
      className={tagClass}
    >
      {icon && <span className="tag-icon">{icon}</span>}
      {children}
    </AntTag.CheckableTag>
  );
}

export default Tag;
